import { useSelector } from "react-redux";
import { AuthType } from 'types';

export const useAuth = (): AuthType => useSelector(state => state.auth);